import { render, staticRenderFns } from "./tax-invoice-record-page.vue?vue&type=template&id=2e51872f&"
import script from "./tax-invoice-record-page.vue?vue&type=script&lang=js&"
export * from "./tax-invoice-record-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports